import React, { useRef, useEffect, useState } from "react";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, Loader, Dimmer, Label, Input, DropdownProps, TextAreaProps } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import ImageZoom from "../../components/ImageZoom";
import ModalYesNo from "../../components/ModalYesNo";

import ResellersRepository, { IResellerListModel } from "../../Repositories/ResellersRepository";
import TrocaRepository from "../../Repositories/ExchangeRepository";
import ImagemRepository from "../../Repositories/ImagesRepository";
import CategoriaRepository from "../../Repositories/CategoriaRepository";
import ProdutoRepository, { IProdutoListModel } from "../../Repositories/ProdutoRepository";

import { eBanho, ICategoria, IImagem, ITroca } from "../../interfaces";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";

interface State extends Omit<ITroca, "banho" | "status" | "step"> {
    banho: string | number;
    images: IImagem[];
    cidade: string;
    uf: string;
    apiErrors: IAliancaErrors;
}

interface Props {
    onSuccess: () => void;
}

const initialState: State = {
    id: "",
    data: "",
    representanteId: "",
    revendedorId: "",
    categoriaId: "",
    produtoId: "",
    banho: "",
    descricao: "",
    dataTroca: "",
    images: [],
    cidade: "",
    uf: "",
    apiErrors: { errors: [] }
}

const CadastrarTroca: React.FC<Props> = (props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);
    const [revendedores, setRevendedores] = useState<IResellerListModel[]>([]);
    const [categorias, setCategorias] = useState<ICategoria[]>([]);
    const [produtos, setProdutos] = useState<IProdutoListModel[]>([]);


    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role, refId } = GetUser();

    const banhos = [
        { key: 0, value: eBanho.Ouro, text: "Ouro" },
        { key: 1, value: eBanho.Prata, text: "Prata" },
        { key: 2, value: eBanho.Rodio, text: "Ródio" },
    ];

    const load = async () => {
        setLoading(true);

        try {
            const [resellers, categories, products] = await Promise.all([
                ResellersRepository.List({ filter: "STATUS <= 1" }),
                CategoriaRepository.List({
                    filter: "STATUS == 1"
                }),
                ProdutoRepository.List({
                    filter: "STATUS == 1"
                })
            ]);
            setRevendedores(resellers.list as IResellerListModel[]);
            setCategorias(categories.list as ICategoria[]);
            setProdutos(products.list as IProdutoListModel[]);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles]);

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const onRemove = async (id: string) => {
        await ImagemRepository.DeleteById(id);
        load();
    }

    const handleSubmitForm = async () => {
        if (selectedFiles.length >= 1) {
            try {
                setLoading(true);

                const data = new FormData();

                data.append("representanteId", refId);
                data.append("revendedorId", state.revendedorId);
                data.append("categoriaId", state.categoriaId);
                data.append("produtoId", state.produtoId);
                data.append("banho", state.banho as string);
                data.append("descricao", state.descricao);

                for (const file of selectedFiles) {
                    data.append("files", file);
                }

                const response = await TrocaRepository.Insert(data);

                setState(initialState);
                setSelectedFiles([]);
                setPreview([]);

                toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
                setOpen(false);
                props.onSuccess();

            } catch (err) {
                if (err.response.status === 401) {
                    window.location.href = "/";
                }

                setState({ ...state, apiErrors: err.response.data });

                const error = errors.getApiErrors(state.apiErrors);

                if (error !== undefined)
                    toast(error, { position: "top-center", type: "error" });
            }
            setLoading(false);
        } else {
            toast("❌ É necessário inserir no mínimo 1 foto.", { position: "top-center", type: "error" });
        }
    }

    const handleOpen = () => {
        load();
        setOpen(true);
    }

    const handleClose = () => {
        setState(initialState);
        setOpen(false);
        setSelectedFiles([]);
        setPreview([]);
    }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const onRevendedorChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        const findRevendedor = revendedores.find(revendedor => revendedor.id === value);

        setState({
            ...state,
            [name]: value,
            cidade: findRevendedor?.cidade || "",
            uf: findRevendedor?.uf || "",
            apiErrors: { errors: [] }
        });
    }

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const onChangeTextArea = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const editarContent = (
        <Modal.Content scrolling>
            {loading &&
                    <CustomLoader />}
            {!loading &&
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field width={10} error={hasError("RevendedorId")} required>
                            <label>Revendedor</label>
                            <Form.Dropdown
                                fluid
                                selection
                                search
                                scrolling
                                name="revendedorId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.revendedorId}
                                onChange={onRevendedorChange}
                                options={revendedores.map(revendedor => { return { key: revendedor.id, value: revendedor.id, text: revendedor.nome } })}
                            />
                            {hasError("RevendedorId") && <Label pointing prompt>{getMessage("RevendedorId")}</Label>}
                        </Form.Field>
                        <Form.Field width={4}>
                            <label>Cidade</label>
                            <Input
                                readOnly
                                placeholder="Cidade"
                                value={state.cidade}
                            />
                        </Form.Field>
                        <Form.Field width={2}>
                            <label>Estado</label>
                            <Input
                                readOnly
                                placeholder="Estado"
                                value={state.uf}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field width={5} error={hasError("CategoriaId")} required>
                            <label>Categoria</label>
                            <Form.Dropdown
                                fluid
                                selection
                                search
                                scrolling
                                name="categoriaId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.categoriaId}
                                onChange={onDropdownChange}
                                options={categorias.map(categoria => { return { key: categoria.id, value: categoria.id, text: categoria.nome } })}
                            />
                            {hasError("CategoriaId") && <Label pointing prompt>{getMessage("CategoriaId")}</Label>}
                        </Form.Field>
                        <Form.Field
                            width={7}
                            error={hasError("ProdutoId")}
                            required
                            disabled={!state.categoriaId.length}
                        >
                            <label>Produto</label>
                            <Form.Dropdown
                                fluid
                                selection
                                search
                                scrolling
                                name="produtoId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.produtoId}
                                onChange={onDropdownChange}
                                options={
                                    produtos
                                        .filter(produto => produto.categoria === categorias.find(categoria => categoria.id === state.categoriaId)?.nome)
                                        .map(produto => { return { key: produto.id, value: produto.id, text: produto.nome } })
                                }
                            />
                            {hasError("ProdutoId") && <Label pointing prompt>{getMessage("ProdutoId")}</Label>}
                        </Form.Field>
                        <Form.Field
                            width={4}
                            error={hasError("Banho")}
                            required
                            disabled={!state.produtoId.length}
                        >
                            <label>Banho</label>
                            <Form.Dropdown
                                fluid
                                selection
                                search
                                scrolling
                                name="banho"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.banho}
                                onChange={onDropdownChange}
                                options={banhos}
                            />
                            {hasError("Banho") && <Label pointing prompt>{getMessage("Banho")}</Label>}
                        </Form.Field>
                    </Form.Group>
                    <Form.Field error={hasError("Descricao")} required>
                        <label>Descrição</label>
                        <Form.TextArea
                            placeholder="Descrição do defeito"
                            name="descricao"
                            value={state.descricao}
                            onChange={onChangeTextArea}
                        />
                        {hasError("Descricao") && <Label pointing prompt>{getMessage("Descricao")}</Label>}
                    </Form.Field>
                    <Form.Field>
                        <p>
                            <strong>
                                FOTOS NECESSÁRIAS:<br /> FOTOS DO PRODUTO COM DEFEITO.
                            </strong>
                        </p>
                        <Button
                            content="Selecionar fotos"
                            icon="images"
                            fluid
                            onClick={onButtonClick}
                            color="black"
                        />
                        <input
                            ref={fileInputRef}
                            type="file"
                            hidden
                            multiple
                            accept="image/*"
                            onChange={onSelectFile}
                        />
                    </Form.Field>
                    <Grid columns={4} doubling>
                        {state.images.length > 0 &&
                            state.images.map((x, index) =>
                                <Grid.Column key={`image-${index}`}>
                                    <Image
                                        fluid
                                        label={<ImageZoom imagePath={`${api.defaults.baseURL}/images/${x.arquivo}`} />}
                                        src={`${api.defaults.baseURL}/images/${x.arquivo}`}
                                    />
                                    <ModalYesNo
                                        trigger={<Button icon="trash" color="red" attached="bottom" disabled={role !== "Admin"} />}
                                        header="Apagar"
                                        content="Deseja realmente apagar esta foto?"
                                        onSuccess={() => onRemove(x.id || "")}
                                    />
                                </Grid.Column>
                            )}
                        {preview.length > 0 &&
                            preview.map((x, index) =>
                                <Grid.Column key={`image-${index}`}>
                                    <Image
                                        fluid
                                        label={<ImageZoom imagePath={x} />}
                                        src={x}
                                    />
                                    <ModalYesNo
                                        trigger={<Button icon="trash" color="red" attached="bottom" />}
                                        header="Apagar"
                                        content="Deseja realmente apagar esta foto?"
                                        onSuccess={() => onRemovePreview(x, index)}
                                    />
                                </Grid.Column>
                            )}
                    </Grid>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={editarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Nova",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
};

export default CadastrarTroca;
